import React from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& legend': {
      fontSize: ({ typography }) => typography.fontSizeLegend,
    },

    '& label': {
      fontSize: ({ typography }) => typography.fontSizeLabel,
    },
  },
}));

export default function MaskField({
  label,
  mask,
  maskPlaceholder = null,
  alwaysShowMask = false,
  onChange,
  value,
  defaultValue,
  ...other
}) {
  const classes = useStyles({
    typography: {
      fontSizeLegend: other.fontSizeLegend,
      fontSizeLabel: other.fontSizeLabel,
    },
  });

  return (
    <InputMask
      mask={mask}
      maskChar={maskPlaceholder}
      alwaysShowMask={alwaysShowMask}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
    >
      {() => (
        <TextField
          label={label}
          defaultValue={defaultValue}
          className={classes.textField}
          {...other}
        />
      )}
    </InputMask>
  );
}
